export default {
    label: 'Gallery',
    name: 'gallery',
    file: 'src/content/components/gallery.json',
    format: 'json',
    i18n: true,
    create: false,
    fields: [
        {
            label: 'Go to previous image',
            name: 'go_to_previous_image',
            widget: 'string',
            required: true,
            i18n: true,
        },
        {
            label: 'Go to next image',
            name: 'go_to_next_image',
            widget: 'string',
            required: true,
            i18n: true,
        },
        {
            label: 'Go to image',
            name: 'go_to_image',
            widget: 'string',
            required: true,
            i18n: true,
        },
    ]
}